import { render, staticRenderFns } from "./base_course.vue?vue&type=template&id=6b735090&scoped=true&"
import script from "./base_course.vue?vue&type=script&lang=js&"
export * from "./base_course.vue?vue&type=script&lang=js&"
import style0 from "./base_course.vue?vue&type=style&index=0&id=6b735090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b735090",
  null
  
)

export default component.exports